export default (value) => {
  if (value == null || value === '') {
    return 'Unknown'
  }

  return value
}
